import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"video_corse",
    list_id:"video_corse_list",
    x_column_list_arr:[
      {"key":"a_title","name":"제목","width":"220","is_show":"1"},
      {"key":"a_category","name":"카테고리","width":"200","is_show":"1"},
      {"key":"row_view_section","name":"강의/섹션","width":"100","is_show":"1"},
      {"key":"row_view_stu_cnt","name":"수강","width":"80","is_show":"1"},
      {"key":"row_view_request","name":"신청","width":"80","is_show":"1"},
      {"key":"a_state","name":"상태","width":"100","is_show":"1"},
      {"key":"a_subject","name":"과목","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':100,
      'order_id':'a_title',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
      "s_category_seq":"",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);

  return xColumnArr;
};

export default getXcolumnJson;